






















import Vue, { PropType } from "vue";
import PrintTypeButton from "@/components/PrintTypeButton.vue";
import { validationMixin } from "vuelidate";
import {
  PrintTypeInterface,
  PrintTypes
} from "@/model/components/PrintTypeInterface.ts";

function frontSideSelected(
  val: typeof PrintTypes["COLOR" | "MONOCHROME" | "NONE"]
) {
  return val !== "none";
}

export default Vue.extend({
  name: "PrintType",

  components: {
    PrintTypeButton
  },

  mixins: [validationMixin],

  props: {
    printType: {
      type: Object as PropType<PrintTypeInterface>
    }
  },

  validations: {
    frontSideColor: {
      frontSideSelected: frontSideSelected
    }
  },

  computed: {
    frontSideColor(): typeof PrintTypes["COLOR" | "MONOCHROME" | "NONE"] {
      return this.printType.frontSideColor;
    }
  },

  methods: {
    updatePrintType(payload: PrintTypeInterface): void {
      this.$v["frontSideColor"].$touch();
      this.$emit("updatePrintType", payload);
    }
  }
});
